import type { ConversationId } from "@redotech/effect-api-shared/ids/definitions";
import { useMemo } from "react";
import { useSingleConversationData } from "./use-conversation-data";

export function useConversationView(conversationId: ConversationId) {
  const { conversation, threads, messages, isLoading } =
    useSingleConversationData(conversationId);

  // TODO: Fetch actual customer name from Customer model using conversation.mongoCustomerId
  const customerName = "Customer";

  const latestMessageTime = useMemo(() => {
    if (messages.length === 0) {
      return null;
    }
    const sorted = [...messages].sort(
      (a, b) => new Date(b.sentAt).getTime() - new Date(a.sentAt).getTime(),
    );
    return new Date(sorted[0].sentAt);
  }, [messages]);

  return { conversation, threads, isLoading, customerName, latestMessageTime };
}
